<template>
  <div class="partnerProjects">
    <template v-if="projectList.length">
      <div
        v-for="(item, index) in projectList"
        :key="index"
        class="partnerProjectsCard"
      >
        <div class="partnerProjectsCardTitle">{{ item.projectName }}</div>
        <div class="partnerProjectsCardMeta">
          <div class="partnerProjectsCardMetaItem">
            <img src="@/assets/images/rqIcon.png" alt="" />
            <span>{{ item.projectDate || "--" }}</span>
          </div>
          <div class="partnerProjectsCardMetaItem">
            <img src="@/assets/images/priceIcon.png" alt="" />
            <span class="partnerProjectsCardAmount">¥{{ item.projectAmount }}</span>
          </div>
        </div>
      </div>
    </template>
    <None v-else />
  </div>
</template>

<script>
export default {
  name: "PartnerProjects",
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    projectList() {
      const projects = this.data && this.data.projects;
      return Array.isArray(projects) ? projects : [];
    },
  },
};
</script>

<style lang="less" scoped>
.partnerProjects {
  padding: 32px;
  background: #fff;
  min-height: 300px;
}
.partnerProjectsCard {
  background: #f9fafb;
  border-top: 4px solid #00d8c3;
  padding: 20px 24px;
  margin-bottom: 16px;
  &:last-child {
    margin-bottom: 0;
  }
}
.partnerProjectsCardTitle {
  margin-bottom: 12px;
  font-size: 18px;
  font-weight: 600;
  color: #00161a;
  line-height: 1.4;
}
.partnerProjectsCardMeta {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 24px;
}
.partnerProjectsCardMetaItem {
  display: flex;
  align-items: center;
  font-size: 14px;
  color: #525f66;
  img {
    width: 14px;
    height: 14px;
    margin-right: 4px;
  }
}
.partnerProjectsCardAmount {
  color: #00d8c3;
  font-weight: 500;
}
</style>
